.progress {
  outline: 4px solid var(--default-secondary-color);
  background-color: var(--default-secondary-color);
  border-radius: 50%;
  svg {
    color: #ffffff !important;
  }
}

.shallowTooltip {
  position: absolute;
  width: 70%;
  height: 20px;
  top: var(--spacer);
  z-index: 1;
}
